<template>
    <Headify :data="headMeta" />

    <div class="min-h-screen bg-white">
        <NavMain :key="route.name" />

        <div class="flex flex-1 flex-col lg:pl-64">
            <main class="flex-1">
                <div class="mx-auto w-full max-w-7xl px-2 pt-12 sm:px-4 lg:pt-4">
                    <div class="py-2">
                        <Breadcrumbs :links="breadcrumbsLinks" />
                    </div>

                    <div class="space-y-6 py-6">
                        <div class="www py-2 sm:p-4">
                            <label
                                for="language"
                                class="block text-sm font-medium text-gray-700"
                            >
                                {{ t('language') }}
                            </label>
                            <select
                                id="role"
                                v-model="localSettings.language"
                                name="role"
                                class="mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
                            >
                                <option
                                    v-for="code in langsAvailable"
                                    :key="code"
                                    :value="code"
                                >
                                    {{ t(code) }}
                                </option>
                            </select>
                        </div>

                        <div class="www px-1 py-2 text-right sm:p-4">
                            <ActionButton
                                :value="t('buttonSave')"
                                state="primary"
                                :icon="MdiContentSave"
                                @click="saveSettings(localSettings)"
                            />
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script setup>
    import { useRoute } from 'vue-router';
    import { t, lang } from '../composables/i18n';
    import { keeper } from '../composables/utils';
    import Headify from '../components/Headify.vue';
    import navs from '../composables/navs';
    import Breadcrumbs from '../ui/Breadcrumbs.vue';
    import NavMain from '../ui/NavMain.vue';
    import ActionButton from '../ui/ActionButton.vue';
    import { MdiContentSave } from 'materialdesignicons-vue3/icons/';

    const route = useRoute();
    const langsAvailable = ['cs', 'en'];
    const localSettings = {
        language: lang,
        editorShowBlocks: true,
    };

    const saveSettings = (localSettings) => {
        for (let setting in localSettings) {
            keeper(setting, localSettings[setting]);
        }
        document.location.href = route.path;
    };

    const breadcrumbsLinks = [
        {
            name: 'dashboard',
            title: t('Dashboard'),
        },
        {
            name: 'settings',
            title: t('Settings'),
            final: true,
        },
    ];

    const headMeta = navs().metaFind(route.name);
</script>
